import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const { FiLock, FiFileText, FiShield } = FiIcons;

const Legal = () => {
  return (
    <div className="bg-white font-inter">
      {/* Header Section - Updated to a slightly deeper, elegant slate gradient for better definition */}
      <section className="bg-gradient-to-b from-slate-200/50 via-slate-100/20 to-white py-24 border-b border-divider relative overflow-hidden">
        {/* Subtle background decorative element */}
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-extrabold text-primary mb-6 tracking-tight"
          >
            Aspek Legal & Etika
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-lg md:text-xl text-secondary font-medium"
          >
            Komitmen kami terhadap keamanan data dan integritas akademik Bapak/Ibu.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-4">
          <div className="space-y-12">
            <motion.section 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="p-8 md:p-12 border border-divider rounded-2xl bg-white hover:shadow-sm transition-shadow"
            >
              <div className="flex items-center gap-5 mb-8">
                <div className="w-14 h-14 rounded-xl bg-primary/5 flex items-center justify-center">
                  <SafeIcon icon={FiLock} className="text-3xl text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-primary tracking-tight">Kebijakan Privasi</h2>
              </div>
              <p className="text-secondary text-lg leading-relaxed mb-8 font-normal">
                Kerahasiaan data Bapak/Ibu adalah prioritas utama kami. Semua naskah dan data penelitian yang dikirimkan kepada kami akan dijaga kerahasiaannya dan tidak akan dibagikan kepada pihak ketiga manapun.
              </p>
              <ul className="space-y-4">
                {[
                  'Enkripsi data selama proses pengiriman',
                  'Akses terbatas hanya untuk tim yang bertugas',
                  'Penghapusan data permanen setelah proyek selesai (berdasarkan permintaan)'
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start text-secondary font-medium">
                    <div className="w-1.5 h-1.5 bg-primary/30 rounded-full mt-2.5 mr-4 shrink-0"></div>
                    <span className="text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.section>

            <motion.section 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="p-8 md:p-12 border border-divider rounded-2xl bg-white hover:shadow-sm transition-shadow"
            >
              <div className="flex items-center gap-5 mb-8">
                <div className="w-14 h-14 rounded-xl bg-primary/5 flex items-center justify-center">
                  <SafeIcon icon={FiShield} className="text-3xl text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-primary tracking-tight">Etika Akademik</h2>
              </div>
              <p className="text-secondary text-lg leading-relaxed font-normal">
                Akademika Support berkomitmen untuk mendukung integritas akademik. Kami tidak melayani penulisan substansi (ghostwriting), manipulasi data, atau tindakan lain yang melanggar etika ilmiah. Layanan kami murni bersifat dukungan teknis, visual, dan bahasa.
              </p>
            </motion.section>

            <motion.section 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="p-8 md:p-12 border border-divider rounded-2xl bg-white hover:shadow-sm transition-shadow"
            >
              <div className="flex items-center gap-5 mb-8">
                <div className="w-14 h-14 rounded-xl bg-primary/5 flex items-center justify-center">
                  <SafeIcon icon={FiFileText} className="text-3xl text-primary" />
                </div>
                <h2 className="text-2xl font-bold text-primary tracking-tight">Syarat & Ketentuan</h2>
              </div>
              <p className="text-secondary text-lg leading-relaxed font-normal">
                Setiap proyek akan dimulai setelah adanya kesepakatan tertulis mengenai ruang lingkup kerja, biaya, dan jangka waktu pengerjaan. Kami menjamin kualitas hasil kerja sesuai dengan standar yang disepakati bersama.
              </p>
            </motion.section>
          </div>

          <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mt-20 text-center text-sm font-bold text-secondary/60 uppercase tracking-[0.2em]"
          >
            Terakhir diperbarui: 15 Januari 2024
          </motion.div>
        </div>
      </section>
      
      <div className="py-12 bg-white"></div>
    </div>
  );
};

export default Legal;